import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const DownloadIcon = ({ className }) => (
    <svg id="b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.01 19.01" className={className}>
        <g id="c">
            <g id="d">
                <path
                    id="e"
                    d="m18.01,12.34v3.78c0,1.04-.85,1.89-1.89,1.89H2.89c-1.04,0-1.89-.85-1.89-1.89v-3.78"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="f"
                    d="m4.78,7.62l4.73,4.73,4.73-4.73"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="g"
                    d="m9.51,12.34V1"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
            </g>
        </g>
    </svg>
);

DownloadIcon.propTypes = propTypes;
DownloadIcon.defaultProps = defaultProps;

export default DownloadIcon;
